module.exports = __webpack_public_path__ + "img/1970East-080_WEB-min.99052c81.jpg";